import Vue from 'vue'
import Router from 'vue-router'
import Full from '@/containers/Full'
import Error401 from '@/views/Error401'
import Auth from '@/features/Auth'
import Logout from '@/features/Auth/logout'
import store from '@/store'
import formula from '@/features/Formula/routes'
import role from '@/features/Role/routes'
import user from '@/features/User/routes'
import dashboard from '@/features/Dashboard/routes'
import seeder from '@/features/Seeder/routes'
import competencia from '@/features/Competencia/routes'
import arvore from '@/features/Arvore/routes'
import centroCusto from '@/features/Centro/routes'
import periodo from '@/features/Periodo/routes'
import indicador from '@/features/Indicador/routes'
import pergunta from '@/features/Pergunta/routes'
import perguntaGrupo from '@/features/PerguntaGrupo/routes'
import NoConnection from "@/views/NoConnection"

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: 'auth.index',
    component: Auth,
    meta: {requiresAuth: false, label: 'Login'}
  },
  {
    path: '/',
    name: 'Home',
    component: Full,
    redirect: '/dashboard',
    meta: {
      requiresAuth: true,
      label: 'Home'
    },
    props: true,
    children: [
      {
        path: '/error/network',
        name: 'error.network',
        component: NoConnection,
        meta: {requiresAuth: false, label: 'No Connection'}
      },
      {
        path: '/logout',
        name: 'logout',
        component: Logout
      },
      {
        path: '/erro401',
        name: 'erro401',
        component: Error401
      },
      ...dashboard,
      ...formula,
      ...user,
      ...role,
      ...seeder,
      ...competencia,
      ...arvore,
      ...centroCusto,
      ...periodo,
      ...indicador,
      ...pergunta,
      ...perguntaGrupo
    ]
  }
]
const router = new Router({
  //mode: 'history',
  linkActiveClass: 'open active',
  linkExactActiveClass: 'current-page',
  scrollBehavior: () => ({y: 0}),
  routes
})

const checkAuth = async (to, from, next) => {
  const {access_token} = store.state.Auth
  if (to.name === 'auth.index') {
    return
  }
  if (_.isEmpty(access_token)) {

    if (to.name) {
      store.commit('SET_REDIRECT', {redirect: to.name})
    }
    next({name: 'auth.index'})
  }
}

router.beforeEach(async (to, from, next) => {
  if (!to.meta.requiresAuth) {
    next()
  }
  await checkAuth(to, from, next)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js